export default __webpack_public_path__ + "static/media/018-dock.fdf0064a.png";